import React from "react";
import { createContext } from "react";
import AttToken from "../services/AttToken";
import Empresas from "../services/Empresas";
import { IEmpresasStore } from "./IEmpresasStore";
import { useQuery } from "react-query";
import { toast } from "react-toastify";

const empresaService = new Empresas();

export type empresaType = {
  id?: string;
  nome: string;
  cnpj: string;
  status: string;
  emailNotificacao: string | null;
  dataCadastro?: number;
  formMigrado?: boolean;
  gerenciaMigrada?: boolean;
  migrado?: boolean;
  planoDeAcao?: boolean;
  dominio?: string;
  selectExecutionsLimit?: number;
};

const initialState = {
  empresas: [] as empresaType[],
  onLoading: false,
  refetch: () => {},
};

export const EmpresasContext = createContext<IEmpresasStore>(initialState);
export default function EmpresasProvider({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["GET_EMPRESAS"],
    queryFn: async () => {
      const token = await AttToken();
      if (!token) throw new Error('Token não encontrado');
      try {
        const response: { empresas?: empresaType[] } | undefined = await empresaService.getAll(token);
        if (!response?.empresas) throw new Error('Erro ao buscar empresas');
        toast.success('Empresas carregadas!', { toastId: 'getEmpresas_success' });
        return response.empresas;
      } catch (error) {
        toast.error('Erro ao carregar empresas', { toastId: 'getEmpresas_error' });
        throw error;
      }
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });

  const onLoading = isLoading || isFetching;

  const store = {
    empresas: data ?? [],
    onLoading,
    refetch,
  };
  return <EmpresasContext.Provider value={store}>{children}</EmpresasContext.Provider>;
}
